module.exports = __webpack_public_path__ + "static/tesla-af6a28790bf27a98ab2e4b59183678a7.jpeg";